export default __webpack_public_path__ + "static/media/mba-leader-woman-v1.5f7a5402.png";